import * as React from 'react'
import CartLogic from '../CartLogic'
import UserLogic from '../UserLogic'
import OrdersLogic from '../OrdersLogic'
import AttachmentsLogic from '../AttachmentsLogic'
import NotesLogic from '../NotesLogic'
import AddressValidationService from './../AddressValidationService'
import VideoPopupLogic from '../VideoPopupLogic'
import StaticChatWidget from '../StaticChatWidget'

const App = props => {
  const { children } = props
  return <>
    <UserLogic>
      <CartLogic>
        <OrdersLogic>
          <AttachmentsLogic>
            <NotesLogic>
              <AddressValidationService>
                <VideoPopupLogic>
                  {children}
                </VideoPopupLogic>
              </AddressValidationService>
            </NotesLogic>
          </AttachmentsLogic>
        </OrdersLogic>
      </CartLogic>
    </UserLogic>

    <StaticChatWidget />
  </>
}

export default App
